'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.fatigueReport',
dependencies:['ui.router'],
configs:[
require('./fatigueReportConfig')],

components:[
require('./fatigueReportController'),
require('./components/reportRasterSchedule/reportRasterScheduleDirective'),
require('./components/reportTimelineSchedule/reportTimelineScheduleDirective')]});
//# sourceMappingURL=index.js.map
